<template>
  <b-modal
    id="modalDownloadQuotations"
    ref="modalDownloadQuotations"
    :no-enforce-focus="true"
    :no-close-on-backdrop = 'true'
    size='lg'
    @hidden="modalDownloadQuotationsOnHidden"
  >
    <div slot="modal-title">
      {{ modalTitle | translate }}
    </div>
    <div class="mb-3">
      <p>
        {{ 'The quotation download has been requested, the system will generate an Excel file containing the list of quotations based on applied filters' | translate }}.
      </p>
      <p>
        {{ 'When the required file is ready, the download link will be displayed in the in bar by pressing the icon' | translate }} <i class="fas fa-cloud-download-alt"></i>
      </p>
    </div>
    <b-form>
      <b-form-row>
        <form-thux-horizontal-datetime
          :validator="$v.printForm.date_q__gte"
          :label-form="'Minimum date (optional)' | translate"
          labelColsSm="3"
          labelColsLg="3"
          class-form="col-lg-12 mb-2 mt-2"
          type="date"
          :value="dateRef"
          :placeholder="$t('Leave empty to export all data')"
          @change="setMinDate"
        />
        <small class="col-12 offset-sm-3 col-sm-9 form-text text-muted mb-2">
          {{ 'Does not export quotations earlier than this date' | translate }}
        </small>
      </b-form-row>
    </b-form>
    <div slot="modal-footer">
      <b-btn class="mr-3" variant="default" @click.prevent="closeAndGoToList()">
        {{ 'Cancel' | translate }}
      </b-btn>
      <b-btn
        variant="primary"
        :disabled="$v.printForm.$invalid"
        @click.prevent="closeAndGenerateJob()"
      >
        {{ 'OK' | translate }}
      </b-btn>
    </div>
  </b-modal>
</template>

<script>
import FormThuxHorizontalDatetime from '@/components/form-thux-horizontal-components/FormThuxHorizontalDatetimePicker'

export default {
  name: 'DownloadQuotationsModal',
  data () {
    return {
      printForm: {},
      dateRef: undefined
    }
  },
  components: {
    'form-thux-horizontal-datetime': FormThuxHorizontalDatetime
  },
  mounted () {
    this.openModalDownloadQuotations()
  },
  computed: {
    modalTitle () {
      return this.$t('Excel list of all quotations (construction sites and safety)')
    }
  },
  methods: {
    openModalDownloadQuotations () {
      this.$refs.modalDownloadQuotations.show()
    },
    modalDownloadQuotationsOnHidden (evt) {
      this.$emit('close-modal')
    },
    closeAndGoToList (evt) {
      this.$emit('close-modal')
    },
    setMinDate (evt) {
      const date = evt.date
      this.$set(this.printForm, 'date_q__gte', date ? date.format('YYYY-MM-DD') : undefined)
    },
    closeAndGenerateJob () {
      this.$emit('generate-job', this.printForm)
    }
  },
  validations () {
    return {
      printForm: { date_q__gte: { } }
    }
  }
}
</script>
